import { randomBytes } from 'crypto-browserify';

export const secureRandomInt = (min, max) => {
  const range = max - min;
  if (range <= 0) {
    throw new Error('max must be greater than min');
  }

  const maxRange = 256;
  const byte = randomBytes(1)[0];

  // Rejection sampling
  if (byte >= Math.floor(maxRange / range) * range) {
    return secureRandomInt(min, max);
  }

  return min + (byte % range);
};
